
const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'ri-phone-line',
      title: '客服热线',
      content: '400-888-1716',
      description: '工作时间：周一至周日 9:00-18:00',
      bgColor: 'bg-primary',
      iconColor: 'text-accent'
    },
    {
      icon: 'ri-mail-line',
      title: '商务邮箱',
      content: 'BS@tea1716.com',
      description: '合作洽谈专用邮箱',
      bgColor: 'bg-[#603B28]',
      iconColor: 'text-accent'
    },
    {
      icon: 'ri-wechat-line',
      title: '微信客服',
      content: 'MaBangRuiGong',
      description: '扫码添加企业微信',
      bgColor: 'bg-slate-600',
      iconColor: 'text-accent'
    },
    {
      icon: 'ri-map-pin-line',
      title: '公司地址',
      content: '云南省普洱市思茅区',
      description: '茶马古道文化园',
      bgColor: 'bg-[#3E3A39]',
      iconColor: 'text-accent'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-gray-50">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary font-serif mb-3">
            联系方式
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            多种联系方式，随时为您提供专业服务
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {contactMethods.map((method, index) => (
              <div
                key={index}
                className={`${method.bgColor} rounded-xl p-4 lg:p-6 text-white hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl`}
              >
                <div className="text-center">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3 lg:mb-4">
                    <i className={`${method.icon} text-xl lg:text-2xl ${method.iconColor}`}></i>
                  </div>
                  <h3 className="text-base lg:text-lg font-bold font-serif mb-1 lg:mb-2">
                    {method.title}
                  </h3>
                  <p className="text-sm lg:text-base font-medium mb-1 lg:mb-2 text-accent">
                    {method.content}
                  </p>
                  <p className="text-xs lg:text-sm text-gray-200">
                    {method.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
